import { ComponentType, Fragment } from 'react';
import { ConversationMessage, DomesticV2ConversationsConversationIdGet200Response } from 'swagger/models';
import { MESSAGE_TYPES } from '../constants';
import { userNameDisplay, isValidUrl } from '../utils';
import BookInquiryBoxActions from './BookInquiryBoxActions';
import BookNowBoxActions from './BookNowBoxActions';
import DefaultMessage from './DefaultMessage';
import EditInquiryBoxActions from './EditInquiryBoxActions';
import EditInquiryMessage from './EditInquiryMessage';
import ModificationMessage from './ModificationMessage';
import {
  ApprovedOrRolodexCancelMessage,
  OwnerSpecialOfferMessage,
  PreApprovalMessage,
  RenterSpecialOfferMessage,
} from './otherMessages';
import { SpecialMessageProps } from './types';

const specialMessageComponentsMap = {
  renter: {
    [MESSAGE_TYPES.ownerModification]: ModificationMessage,
    [MESSAGE_TYPES.preApproval]: PreApprovalMessage,
    [MESSAGE_TYPES.bookingOwnerEditInquiry]: EditInquiryMessage,
    [MESSAGE_TYPES.bookingRenterEditInquiry]: EditInquiryMessage,
    [MESSAGE_TYPES.rolodexCancel]: ApprovedOrRolodexCancelMessage,
    [MESSAGE_TYPES.approved]: ApprovedOrRolodexCancelMessage,
    [MESSAGE_TYPES.specialOffer]: RenterSpecialOfferMessage,
  },
  owner: {
    [MESSAGE_TYPES.renterModification]: ModificationMessage,
    [MESSAGE_TYPES.preApproval]: PreApprovalMessage,
    [MESSAGE_TYPES.specialOffer]: OwnerSpecialOfferMessage,
  },
};

// eslint-disable-next-line import/prefer-default-export
export const renderMessage =
  (
    conversation: DomesticV2ConversationsConversationIdGet200Response,
    userId: string,
    openEditBookingModal: () => void
  ) =>
  (message: ConversationMessage, index: number) => {
    const userType =
      conversation.my_user_type_in_conversation === 'boat manager'
        ? 'owner'
        : conversation.my_user_type_in_conversation;

    // @ts-ignore
    const { type: msgType, id, body } = message;

    const SpecialMessageComponent: ComponentType<SpecialMessageProps> =
      specialMessageComponentsMap[userType]?.[msgType];

    // @ts-ignore
    const messageTypes = conversation.messages.map(({ type }) => type as string);
    const lastEdits = {
      preApproval: messageTypes.lastIndexOf(MESSAGE_TYPES.preApproval),
      owner: messageTypes.lastIndexOf(MESSAGE_TYPES.bookingOwnerEditInquiry),
      renter: messageTypes.lastIndexOf(MESSAGE_TYPES.bookingRenterEditInquiry),
      bookingOwner: messageTypes.lastIndexOf(MESSAGE_TYPES.ownerModification),
      bookingRenter: messageTypes.lastIndexOf(MESSAGE_TYPES.renterModification),
    };

    const messageProps: SpecialMessageProps = {
      msg: message,
      lastEdits,
      index,
      booking: conversation.booking,
      userType,
      conversation,
      userName: userNameDisplay(conversation, conversation.booking, userId),
    };

    const extraMessages = (
      <>
        <BookNowBoxActions {...messageProps} openEditBookingModal={openEditBookingModal} />
        <EditInquiryBoxActions {...messageProps} />
        <BookInquiryBoxActions {...messageProps} />
      </>
    );

    if (SpecialMessageComponent) {
      return (
        <Fragment key={id}>
          <SpecialMessageComponent {...messageProps} />
          {extraMessages}
        </Fragment>
      );
    }
    const shouldUseDefaultMessage = msgType !== 'booking_owner_decline' || !isValidUrl(body);

    return (
      <Fragment key={id}>
        {shouldUseDefaultMessage && <DefaultMessage key={id} message={message} />}
        {extraMessages}
      </Fragment>
    );
  };
